(function () {
  'use strict';

  var form = document.getElementById('roave-gc-form');
  if (!form) return;

  var variantInput = document.getElementById('roave-gc-variant-id');
  var priceEl = document.getElementById('roave-gc-price');
  var addBtn = document.getElementById('roave-gc-add-btn');
  var recipientSection = document.getElementById('roave-gc-recipient');
  var deliverySection = document.getElementById('roave-gc-delivery');
  var datePickerWrap = document.getElementById('roave-gc-date-picker');
  var deliveryDateInput = document.getElementById('roave-gc-delivery-date');
  var messageInput = document.getElementById('roave-gc-message');
  var charCountEl = document.getElementById('roave-gc-char-count');
  var emailInput = document.getElementById('roave-gc-email');
  var emailVerifyInput = document.getElementById('roave-gc-email-verify');

  var isSomeoneElse = false;

  // ── Set today as minimum delivery date ─────────────
  if (deliveryDateInput) {
    var today = new Date();
    var yyyy = today.getFullYear();
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var dd = String(today.getDate()).padStart(2, '0');
    var todayStr = yyyy + '-' + mm + '-' + dd;
    deliveryDateInput.min = todayStr;
    deliveryDateInput.value = todayStr;
    var maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 90);
    deliveryDateInput.max = maxDate.getFullYear() + '-' + String(maxDate.getMonth() + 1).padStart(2, '0') + '-' + String(maxDate.getDate()).padStart(2, '0');
  }

  // ── Thumbnail gallery ───────────────────────────────
  var thumbBtns = document.querySelectorAll('.roave-gc__thumb');
  var imgSlides = document.querySelectorAll('.roave-gc__img-slide');

  thumbBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(this.dataset.gcThumb, 10);
      thumbBtns.forEach(function (b) { b.classList.remove('roave-gc__thumb--active'); });
      imgSlides.forEach(function (s) { s.classList.add('roave-gc__img-slide--hidden'); });
      this.classList.add('roave-gc__thumb--active');
      var target = document.querySelector('[data-gc-slide="' + idx + '"]');
      if (target) target.classList.remove('roave-gc__img-slide--hidden');
    });
  });

  // ── Amount selection ────────────────────────────────
  var amountBtns = document.querySelectorAll('.roave-gc__amount');

  amountBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      amountBtns.forEach(function (b) { b.classList.remove('roave-gc__amount--active'); });
      this.classList.add('roave-gc__amount--active');
      if (variantInput) variantInput.value = this.dataset.variantId;
      if (priceEl) priceEl.textContent = this.dataset.price;
    });
  });

  // ── Myself / Someone Else toggle ────────────────────
  var toggleBtns = document.querySelectorAll('.roave-gc__toggle-btn');

  toggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      toggleBtns.forEach(function (b) { b.classList.remove('roave-gc__toggle-btn--active'); });
      this.classList.add('roave-gc__toggle-btn--active');
      isSomeoneElse = this.dataset.giftFor === 'someone';

      if (recipientSection) {
        recipientSection.style.display = isSomeoneElse ? 'block' : 'none';
        recipientSection.setAttribute('aria-hidden', String(!isSomeoneElse));
      }
      if (deliverySection) {
        deliverySection.style.display = isSomeoneElse ? 'block' : 'none';
        deliverySection.setAttribute('aria-hidden', String(!isSomeoneElse));
      }

      if (!isSomeoneElse) clearAllErrors();
    });
  });

  // ── Delivery date radio ─────────────────────────────
  var deliveryRadios = document.querySelectorAll('[name="delivery-timing"]');

  deliveryRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (datePickerWrap) {
        datePickerWrap.style.display = this.value === 'specific' ? 'block' : 'none';
      }
    });
  });

  // ── Character counter ───────────────────────────────
  if (messageInput && charCountEl) {
    messageInput.addEventListener('input', function () {
      charCountEl.textContent = this.value.length + '/200 characters';
    });
  }

  // ── Field error helpers ─────────────────────────────
  function getFieldEl(inputId) {
    var input = document.getElementById(inputId);
    return input ? input.closest('.roave-gc__field') : null;
  }

  function setFieldError(inputId, hasError) {
    var field = getFieldEl(inputId);
    if (field) field.classList.toggle('roave-gc__field--error', hasError);
  }

  function clearAllErrors() {
    document.querySelectorAll('.roave-gc__field--error').forEach(function (f) {
      f.classList.remove('roave-gc__field--error');
    });
  }

  // ── Email match validation ──────────────────────────
  function validateEmailMatch() {
    if (!emailInput || !emailVerifyInput) return true;
    var mismatch = Boolean(emailVerifyInput.value && emailInput.value !== emailVerifyInput.value);
    setFieldError('roave-gc-email-verify', mismatch);
    return !mismatch;
  }

  if (emailVerifyInput) {
    emailVerifyInput.addEventListener('blur', validateEmailMatch);
    emailVerifyInput.addEventListener('input', function () {
      var field = getFieldEl('roave-gc-email-verify');
      if (field && field.classList.contains('roave-gc__field--error')) validateEmailMatch();
    });
  }

  // ── Form submit ─────────────────────────────────────
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearAllErrors();

    var valid = true;

    if (isSomeoneElse) {
      var recipientNameEl = document.getElementById('roave-gc-recipient-name');
      var senderNameEl = document.getElementById('roave-gc-sender-name');

      if (!recipientNameEl || !recipientNameEl.value.trim()) {
        setFieldError('roave-gc-recipient-name', true);
        valid = false;
      }
      if (!emailInput || !emailInput.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value)) {
        setFieldError('roave-gc-email', true);
        valid = false;
      }
      if (!validateEmailMatch()) valid = false;
      if (!senderNameEl || !senderNameEl.value.trim()) {
        setFieldError('roave-gc-sender-name', true);
        valid = false;
      }
    }

    if (!valid) {
      var firstError = form.querySelector('.roave-gc__field--error .roave-gc__input');
      if (firstError) firstError.focus();
      return;
    }

    var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
    if (!variantId) return;

    var properties = {};

    if (isSomeoneElse) {
      var rName = document.getElementById('roave-gc-recipient-name');
      var sName = document.getElementById('roave-gc-sender-name');
      var selectedRadio = document.querySelector('[name="delivery-timing"]:checked');

      properties['__shopify_send_gift_card_to_recipient'] = 'true';
      properties['__shopify_offset'] = new Date().getTimezoneOffset().toString();
      if (rName && rName.value.trim()) properties['Recipient name'] = rName.value.trim();
      if (emailInput && emailInput.value.trim()) properties['Recipient email'] = emailInput.value.trim();
      if (messageInput && messageInput.value.trim()) properties['Message'] = messageInput.value.trim();
      if (sName && sName.value.trim()) properties['From'] = sName.value.trim();
      if (selectedRadio && selectedRadio.value === 'specific' && deliveryDateInput && deliveryDateInput.value) {
        properties['Send on'] = deliveryDateInput.value;
      }
    }

    var originalBtnHTML = addBtn.innerHTML;
    addBtn.disabled = true;
    addBtn.textContent = 'ADDING\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw d; });
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('[ROAVE] Gift card add-to-cart error:', err);
        addBtn.disabled = false;
        addBtn.innerHTML = originalBtnHTML;
        if (priceEl) priceEl = document.getElementById('roave-gc-price');
      });
  });

})();
